import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';

import { EmployeeFunction, ScenarioCostCenter } from 'components/types';

import { CapacityResponse } from 'RestAPIs/roster/formation';

import { scenarioAtom } from '../../../atoms';
import { selectedCostCenterAtom, selectedFunctionAtom } from '../../atoms';

import { Box, Stack, TextField, Typography } from '@mui/material';

import { VirtualizedAutocomplete } from 'components/shared';

import { getUniqueFunctionsForCapacity } from '../../util';

interface FormationFiltersProps {
  capacity?: CapacityResponse;
}
const FormationFilters = ({ capacity }: FormationFiltersProps) => {
  const [selectedFunction, setSelectedFunction] =
    useRecoilState(selectedFunctionAtom);
  const [selectedCostCenter, setSelectedCostCenter] = useRecoilState(
    selectedCostCenterAtom
  );
  const scenario = useRecoilValue(scenarioAtom);

  const [functionOptions, setFunctionOptions] = useState<EmployeeFunction[]>(
    []
  );
  const [costCenterOptions, setCostCenterOptions] = useState<
    ScenarioCostCenter[]
  >([]);
  const { t } = useTranslation('common');

  useEffect(() => {
    if (!selectedFunction) {
      setFunctionOptions(
        capacity ? getUniqueFunctionsForCapacity(capacity) : []
      );
    }
  }, [capacity]);

  useEffect(() => {
    if (scenario && !selectedCostCenter) {
      setCostCenterOptions(scenario.costCenters);
    }
  }, [scenario]);

  const onChangeFunction = (e, value) => {
    setSelectedFunction(value as EmployeeFunction);
  };

  const onChangeCostCenter = (e, value) => {
    setSelectedCostCenter(value as ScenarioCostCenter);
  };

  return (
    <Box>
      <Typography variant="h3" mb={3}>
        {t('filter')}
      </Typography>
      <Stack spacing={3}>
        <VirtualizedAutocomplete
          value={selectedCostCenter}
          renderInput={(params) => (
            <TextField {...params} label={t('costCenter')} />
          )}
          options={costCenterOptions}
          optionLabelProp="name"
          getOptionLabel={(o) => {
            if (typeof o === 'string') {
              return o;
            }

            return o.name;
          }}
          onChange={onChangeCostCenter}
          isOptionEqualToValue={(a, b) => a.id === b.id}
          autoHighlight
          fullWidth
        />
        <VirtualizedAutocomplete
          value={selectedFunction}
          options={functionOptions}
          optionLabelProp="description"
          getOptionLabel={(o) => {
            if (typeof o === 'string') {
              return o;
            }

            return o.description;
          }}
          renderInput={(params) => (
            <TextField {...params} label={t('function')} />
          )}
          onChange={onChangeFunction}
          isOptionEqualToValue={(a, b) => a.id === b.id}
          autoHighlight
          fullWidth
        />
      </Stack>
    </Box>
  );
};

export default FormationFilters;
